import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';

export const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px;
  @media (max-width: 480px) {
    padding: 0px 15px;
  }
`;

export const NavbarContainer = styled(Navbar)`
  padding: 0 !important;
  position: sticky;
  top: 0px;
  z-index: 10;
  justify-content: space-between;
  background: transparent;
  backdrop-filter: blur(10px);

  & .navbar-toggler {
    border: 1px solid #fcac01;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    padding: 6px;
    margin-right: 16px;
    @media screen and (min-width: 375px) {
      margin-right: 25px;
    }
    & .navbar-toggler-icon {
      filter: invert(1);
      width: 18px;
      height: 18px;
    }
  }

  & .navbar-collapse-container {
    margin-top: 12px;

    height: calc(100vh - 73px);
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 992px) {
      display: none;
    }
  }
  @media (max-width: 480px) {
    position: sticky;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(25px);
  }
  @media screen and (max-width: 1199px) {
    padding: 16px 40px;
  }
  @media screen and (max-width: 991px) {
    padding: 18px 15px;
    min-height: 73px;
    /* background: #1b1d20 !important; */
  }
  &.onScroll {
    background: radial-gradient(
      106.75% 100% at 57.5% 100%,
      rgb(194 147 0 / 88%) 0%,
      rgb(56 39 29) 100%
    );
  }
`;

const ImgWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  flex-shrink: 0;
  & img {
    width: 100%;
    height: 100%;
    max-width: 100%;
  }
`;

export const NavLogoWrapper = styled.span`
  display: flex;
  align-items: end;
  max-width: 77px;
  max-height: 50px;
  overflow: hidden;
  flex-shrink: 0;
  text-decoration: none;
  cursor: pointer;
  width: 77px;
  //height: 36px;
  overflow: visible;
  & img {
    width: 100% !important;
    height: 100% !important;
    max-width: 100%;
    max-height: 100%;
  }
  @media screen and (max-width: 480px) {
    margin-left: -10px;
  }
  @media screen and (min-width: 375px) {
    max-width: 77px;
  }
`;

export const NavbarLeftContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  align-self: center;
  margin-top: 30px;
  margin-bottom: 15px;
  & .about-link-sm {
  }
`;

export const NavbarMenuItemsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  &.about-link {
    margin-left: 0;
  }
  @media screen and (min-width: 992px) {
    flex-direction: row;
    margin-left: 30px;
  }
`;

export const MenuItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
  font-size: 1rem;
  color: #ffffffb2;
  text-underline-offset: 2px;
  cursor: pointer;

  & :last-child {
    margin-right: 0px;
  }
  &:hover,
  &:focus {
    text-decoration: underline;
    color: #ffffffb2;
  }
  @media screen and (min-width: 992px) {
    margin-right: 24px;
    margin-bottom: 0px;
    & :last-child {
      margin-right: 0px;
    }
  }
`;

export const NavbarRightContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  & .help-btn-container {
    display: flex;
    flex-flow: column;

    width: 100%;
  }
  @media screen and (min-width: 992px) {
    flex-direction: row;
  }
`;
export const BalanceWrapper = styled.div`
  display: none;
  align-items: center;
  line-height: 24px;
  font-weight: 600;
  color: #ffffffb2;
  & .balanceAlgo-yellow {
    color: #fcc601;
  }
  @media screen and (min-width: 992px) {
    display: flex;
  }
`;
export const BalanceImgWrapper = styled(ImgWrapper)`
  width: 20px;
  height: 20px;
  @media screen and (max-width: 991px) {
    width: 15px;
    height: 15px;
  }
`;
export const NavbarButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0px;
  background-color: transparent;
  border: 1px solid #fcc601;
  border-radius: 10px;
  color: #ffffffb2;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  padding: 6px 10px;
  min-width: 120px;
  min-height: 36px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  & .help-brn-text {
    margin-left: 10px !important;
  }
  & a {
    max-width: 167px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: #ffffffb2 !important;
    text-decoration: none !important;
    &.help-support-link {
      display: flex;
    }
    &:hover,
    &:focus,
    &:active {
      color: black !important;
      &.help-support-link {
        color: #fff !important;
      }
    }
  }
  &:not(:disabled):not(.disabled):active:focus,
  &:not(:disabled):not(.disabled):active,
  &:not(:disabled):not(.disabled):active,
  &:hover,
  &:focus {
    background: linear-gradient(92.97deg, #ffdc5e 0.13%, #fcc601 99.87%);
    color: black !important;
    border: 1px solid #fcc601;
    outline: none;
    box-shadow: none;
    &.help-btn {
      color: #ffffffb2 !important;
    }
  }
  &.button-yellow {
    color: black;
    box-shadow: none;
    background: linear-gradient(92.97deg, #ffdc5e 0.13%, #fcc601 99.87%);

    &:not(:disabled):not(.disabled):active:focus,
    &:not(:disabled):not(.disabled):active,
    &:not(:disabled):not(.disabled):active,
    &:hover,
    &:focus {
      color: black;
      border: 1px solid #fcc601;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      outline: none;
    }
    & span {
      max-width: 167px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  &.help-btn {
    &:hover,
    &:active,
    &:focus {
      background: none !important;
    }
  }

  @media screen and (min-width: 375px) {
    min-width: 142px;
    font-size: 14px;
    line-height: 21px;
  }
  @media screen and (min-width: 992px) {
    margin-left: 32px;
    min-width: 100px;
    min-height: 40px;
  }
  &.navbar-btn {
    width: 50px;
    min-height: 50px;
  }
  @media screen and (max-width: 320px) {
    padding: 6px 6px;
  }
`;

export const PlusButton = styled(NavbarButton)`
  background: linear-gradient(92.97deg, #ffdc5e 0.13%, #fcc601 99.87%);
  min-width: 48px !important;
  font-size: 32px;
  font-weight: 300;
  margin-left: 13px;
  & > a {
    color: black !important;
  }
  @media screen and (max-width: 350px) {
    min-width: 35px !important;
  }
`;

export const MobPlusButton = styled.div`
  background: linear-gradient(92.97deg, #ffdc5e 0.13%, #fcc601 99.87%);
  height: 35px;
  width: 35px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  & a {
    font-size: 26px;
    color: black !important;
    text-decoration: none;
  }
`;

export const HelpSupportLink = styled.a`
  &:active, &:focus:, &:active, &:hover {
    color: #fff !important;
  }
`;

export const PurchaseButton = styled(NavbarButton)`
  background: linear-gradient(92.97deg, #ffdc5e 0.13%, #fcc601 99.87%);
  min-width: 114px !important;
  margin-left: 13px;
  & > a {
    color: black !important;
  }
`;

export const ZoneWrapper = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  background: #000000;
  height: 60px;
  position: relative;
  display: flex;
  align-items: center;
  @media screen and (max-width: 991px) {
    margin-bottom: 5px;
    height: 45px;
    justify-content: space-between;
    padding-right: 3px;
  }
`;

export const PurchaseWrapper = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  background: #000000;
  height: 60px;
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 14px;
  @media screen and (max-width: 991px) {
    margin-bottom: 24px;
  }
`;

export const NavbarDropdownBtn = styled(Dropdown)`
  margin-left: 15px;
  &.show {
    & .btn-primary.dropdown-toggle,
    & .btn-primary.dropdown-toggle:focus {
      background: linear-gradient(92.97deg, #1b1d20 0.13%, #1B1D2099.87%);
      border: 1px solid #1b1d20;
      box-shadow: none;
      outline: none;
    }
  }
  & .dropdown-toggle {
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* max-width: 155px; */
    background: transparent;
    border: 1px solid transparent;
    border-radius: 10px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    padding: 6px 10px;
    height: 50px;
    /* width: 70px; */
    margin-top: 5px;
    &:not(:disabled):not(.disabled):active:focus,
    &:not(:disabled):not(.disabled):active,
    &:not(:disabled):not(.disabled):active,
    &:hover,
    &:focus {
      color: white;
      border: 1px solid #1b1d20;
      outline: none;
      box-shadow: none;
    }
    & .span-overflow-container {
      max-width: 90px;
      overflow: hidden;
      margin-left: 5px;
      display: flex;
      & .span-overflow {
        display: inline-block;
        max-width: 80px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        @media screen and (max-width: 350px) {
          max-width: 35px;
        }
        @media screen and (max-width: 320px) {
          max-width: 30px;
        }
      }
    }
    &::after {
      font-size: 20px;
    }
  }
  & .dropdown-toggle::before {
    display: none !important;
  }

  & .dropdown-menu {
    width: 315px;
  }
  @media screen and (max-width: 480px) {
    margin-right: -20px;
    & .dropdown-toggle::after {
      display: none;
    }
  }
  @media screen and (max-width: 350px) {
    width: 100px;
    padding: 6px 6px;
  }
`;

export const NewUserLink = styled.a`
  font-size: 14px;
  line-height: 21px;
  font-weight: 600;
  color: #ffffffb2;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  & .yellow {
    color: #fcc601;
    padding-left: 4px;
  }
  &:hover,
  &:focus {
    text-decoration: none;
    cursor: pointer;
  }
  @media screen and (min-width: 992px) {
    display: none;
  }
`;

export const DropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  & > .wrapper {
    /* width: 50px;
    height: 50px; */
    img {
      border-radius: 50px;
      overflow: hidden;
    }
    &.afk-wrapper {
      display: flex;
      justify-content: center;
      & .afk-check-wrapper {
        position: absolute;
        margin-top: 30px;
        margin-right: -30px;
        & img {
          border-radius: 0;
        }
      }
    }
  }
`;

export const DropDownContent = styled(Dropdown.Menu)`
  background: #262a35;
  border-radius: 20px;
  margin-top: 8px !important;
  padding: 26px 16px;
  z-index: 1000;
`;

export const DropDownAddrContainer = styled.div`
  display: flex;
`;

export const DropDownAddr = styled.div`
  width: 171px;
  max-width: 171px;
  display: block !important;
  justify-content: flex-start !important;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 12px 16px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  margin-right: 12px;
  color: white;
  display: flex;
  justify-content: center;
`;

export const DropDownCopyBtn = styled(Dropdown.Item)`
  height: 48px;
  width: 100px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  font-size: 12px;
  font-weight: 600;
  line-height: 21px;
  color: white;
  box-shadow: none;
  background: linear-gradient(
    92.31deg,
    rgba(109, 107, 107, 0.3) 0%,
    rgba(130, 130, 130, 0.3) 100%
  );
  backdrop-filter: blur(22px);
  border: none;
  letter-spacing: 0.16em;
  span {
    margin-left: 8px;
  }
  &:not(:disabled):not(.disabled):active:focus,
  &:not(:disabled):not(.disabled):active,
  &:not(:disabled):not(.disabled):active,
  &:hover,
  &:focus {
    outline: none;
    background: linear-gradient(
      92.31deg,
      rgba(109, 107, 107, 0.6) 0%,
      rgba(130, 130, 130, 0.6) 100%
    );
    backdrop-filter: blur(22px);
    border: none;
    box-shadow: none;
  }
  &.full-btn {
    width: 100%;
  }
`;

export const DropDownSplit = styled.div`
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin: 20px 0;
`;

export const MenuButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  margin-left: 25px;
  margin-right: 25px;
`;

export const MenuButtonFirstBlock = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
`;

export const MenuButtonText = styled.div`
  color: #ffffffb2;
  font-weight: 600;
`;

export const Line = styled.div`
  border-top: 1px solid gray;
  opacity: 0.3;
`;

export const VerticalLine = styled.div`
  margin-left: 15px;
  margin-right: 15px;
  height: 40px;
  width: 1px;
  background-color: gray;
`;

export const SubWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  margin-right: 5px;
  @media screen and (max-width: 991px) {
    margin-left: 8px;
  }
`;

export const AmountTextWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Text = styled.div`
  color: white;
  user-select: none;
  &.mainBal {
    font-weight: 600;
  }
  &.usdPrice {
    opacity: 0.6;
    font-size: 14px;
  }
  &.plusTxt {
    color: black;
    font-size: 26px;
  }
  &.walletAdd {
    font-size: 14px;
    width: 100%;
  }
  @media screen and (max-width: 991px) {
    font-size: 13px;
    &.usdPrice {
      font-size: 13px;
    }
  }
  @media screen and (max-width: 480px) {
    &.walletAdd {
      width: 100px;
    }
  }
`;

export const MobProfileAppBar = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0px 20px;
  @media screen and (min-width: 991px) {
    display: none;
  }
`;
export const ImageContainer = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  display: inline-flex;
  &.chatIcon {
    width: 35px;
    height: 35px;
    margin-left: 15px;
    margin-top: 12px;
    cursor: pointer;
  }
  & .afk-check-wrapper {
    position: absolute;
    margin-left: 64px;
    margin-top: 58px;
  }
  @media screen and (max-width: 768px) {
    &.chatIcon {
      display: none;
    }
  }
`;

export const MobProfileBalanceBlock = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0px 20px;
  @media screen and (min-width: 991px) {
    display: none;
  }
`;

export const NavTextLink = styled.div`
  display: block;
  @media screen and (max-width: 1300px) {
    display: none;
  }
  @media screen and (max-width: 1700px) {
    &.chatOpened {
      display: none;
    }
  }
`;

export const AccountBalanceBlock = styled.div`
  position: relative;
  min-width: 150px;
  height: 45px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  padding-right: 15px;
  justify-content: space-between;
  margin-top: 8px;
  cursor: pointer;
  @media screen and (max-width: 1700px) {
    width: 130px;
    height: 50px;
    margin-top: 5px;
  }
  @media screen and (max-width: 480px) {
    width: 120px;
    height: 40px;
    margin-top: 10px;
  }
`;

export const ProfilePic = styled.div`
  position: relative;
  height: 50px;
  width: 50px;
`;

export const DropDownArrow = styled.div`
  position: relative;
  height: 15px;
  width: 15px;
  transform: rotate(90deg);
  user-select: none;
  @media screen and (max-width: 480px) {
    height: 12px;
    width: 12px;
    /* margin-right: 5px; */
  }
`;

// Balance Menu
export const BalanceMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: #323539;
  border-radius: 15px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  width: 260px;
  margin-top: 5px;
  z-index: 1;
  @media screen and (max-width: 480px) {
    width: 230px;
  }
`;

export const OverallBalTxt = styled.div`
  background: linear-gradient(to right, #ffdc5e 0%, #fcc601 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 22px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;

  span {
    font-size: 16px;
  }
`;

export const TVATxt = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.36px;
`;

export const currencyNameTxt = styled.div`
  color: #fff;
  font-size: 16px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.24px;
`;

export const LocalCurrencyTxt = styled.div`
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.195px;
`;

export const CurrencyIcon = styled.div`
  position: relative;
  height: 20px;
  width: 20px;
`;

export const AllAmountBlock = styled.div`
  width: 100%;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.05);
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const AmountRow = styled.div`
  display: flex;
  justify-content: space-between;

  &.hide {
    display: none;
  }
`;

export const AmountCol1 = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const AmountCol2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ProfileBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 1px;
`;
